/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaAddPagerCountDto } from '../../models/selettiva-add-pager-count-dto';

export interface ApiWsBridgeAlertcallIdCountPagerPatch$Params {
    /**
     * Alert call ID or irideAlertId
     */
    request: string;

    /**
     * application/json
     */
    body: SelettivaAddPagerCountDto;
}

export function apiWsBridgeAlertcallIdCountPagerPatch(
    http: HttpClient,
    rootUrl: string,
    params: ApiWsBridgeAlertcallIdCountPagerPatch$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, apiWsBridgeAlertcallIdCountPagerPatch.PATH, 'patch');
    if (params) {
        rb.query('request', params.request, {});
        rb.body(params.body, 'Answer to add');
    }

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
    );
}

apiWsBridgeAlertcallIdCountPagerPatch.PATH = '/api/ws-bridge/alertcall/:id/count-pager';
